import {
  faChevronCircleLeft,
  faChevronCircleRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Paginated } from 'common/types/Paginated';
import React from 'react';
import { Button, FormControl, Spinner } from 'react-bootstrap';

export type IPagination = Paginated<{
  className?: string;
  loading?: boolean;
  onPageChange: (page: number, size: number) => void;
  offset?: boolean;
}>;

const Pagination = (props: IPagination) => {
  const currentPage = props.offset ? props.currentPage - 1 : props.currentPage;
  const offset = getFirstItem(currentPage, props.itemsPerPage);
  const lastItem = getLastItem(
    currentPage,
    props.totalPages,
    props.itemsPerPage,
    props.totalCount
  );

  const hasPrevPage = currentPage > 0;
  const hasNextPage = currentPage < props.totalPages - 1;

  const handlePageChange = (dir: string) => {
    if (dir === 'desc') {
      if (!hasPrevPage) return;
      props.onPageChange(props.currentPage - 1, props.itemsPerPage);
    } else {
      if (!hasNextPage) return;
      props.onPageChange(props.currentPage + 1, props.itemsPerPage);
    }
  };

  const handleSizeChange = (size: number) =>
    props.onPageChange(props.currentPage, size);

  return (
    <div className='d-flex'>
      <div className='mr-auto'>
        <div className='d-flex'>
          <div className='text-nowrap mr-2'>Show me </div>
          <FormControl
            as='select'
            style={{ height: '22px', padding: '1px' }}
            onChange={(event) => handleSizeChange(Number(event.target.value))}
            value={props.itemsPerPage}
          >
            <option value='10'>10</option>
            <option value='25'>25</option>
            <option value='100'>100</option>
          </FormControl>

          {props.loading && (
            <div>
              <Spinner animation='border' className='align-self-center ml-3' />
            </div>
          )}
        </div>
      </div>
      <div className={props.className || 'mb-3'}>
        <div className='d-flex align-items-center'>
          <Button
            variant='primary'
            disabled={!hasPrevPage}
            onClick={() => handlePageChange('desc')}
          >
            <FontAwesomeIcon icon={faChevronCircleLeft} />
          </Button>

          <div className='px-2'>
            {offset + ' - ' + lastItem + ' of ' + props.totalCount}
          </div>
          <Button
            variant='primary'
            disabled={!hasNextPage}
            onClick={() => handlePageChange('asc')}
          >
            <FontAwesomeIcon icon={faChevronCircleRight} />
          </Button>
        </div>
      </div>
    </div>
  );
};

function getFirstItem(currentPage: number, pageSize: number) {
  return currentPage * pageSize + 1;
}

function getLastItem(
  currentPage: number,
  totalPages: number,
  pageSize: number,
  totalCount: number
) {
  // Has next page
  if (currentPage < totalPages - 1) {
    return getFirstItem(currentPage, pageSize) + pageSize - 1;
  }
  return totalCount;
}

export default Pagination;
